import React from "react";
import styled from "styled-components";

const ScreenWrapper = styled.g`
  .st3 {
    stroke: #fff;
    stroke-width: 4;
  }
  .st3,
  .st5 {
    fill: none;
  }
  .st10,
  .st5,
  .st6,
  .st7,
  .st8 {
    stroke: #000;
  }
  .st10,
  .st7,
  .st8 {
    fill: none;
    stroke-width: 2;
  }
  .st10,
  .st8 {
    stroke: #fff;
  }
  .st10 {
    stroke-width: 3;
  }
`;

const ScreenIcon = () => (
  <ScreenWrapper>
    <linearGradient
      id="screen_2_"
      x1="174.1382"
      x2="174.1382"
      y1="7.915"
      y2="195.8867"
      gradientTransform="matrix(.9778 .0722 -.0736 .9973 -12.1596 30.2732)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#506d4f" stopOpacity="0" />
      <stop offset="1" stopColor="#506d4f" />
    </linearGradient>
    <circle className="icon-bg" cx="150" cy="150" r="150" />

    <path
      id="screen_1_"
      fill="url(#screen_2_)"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="4"
      d="M250.9 246.12L36.47 230.28 50.31 42.82l214.44 15.84z"
    />
    <g id="arms_2_">
      <path
        d="M163.45 156.89c12.9-2.49 25.8-4.97 38.7-7.46 4.22-10.55 8.44-21.11 12.66-31.66-1.85-3.26-4.89-7.36-7.86-9.65M219.11 104.76c-2.59 2.8-3.96 6.69-3.69 10.5 3.37-2.9 8.68-3.51 12.77-5.24"
        className="st3"
      />
    </g>
    <g id="face_4_">
      <path
        fill="#fff"
        stroke="#fff"
        d="M164.8 111.97c1.34-4.16-.95-8.61-5.1-9.95L82.54 77.21c-4.16-1.34-8.61.95-9.95 5.1l-25.58 34.34s-.33.67-.89 1.82c-.9 13.7-2.12 30.87-3.38 47.78 29.42 10.64 110.09 43.58 114.17 28.33l7.59-38.86.3-43.75z"
      />
      <path
        d="M78.71 132.79c-4.21 9.46 14.32 17.32 18.2 7.72 4.2-9.45-14.32-17.32-18.2-7.72zM116.5 144.28c-4.06 9.11 14.47 16.97 18.2 7.72 4.05-9.1-14.47-16.96-18.2-7.72z"
        className="st5"
      />
      <path
        d="M92.32 138.9c-2.42 5.94-11.69 2-9.1-3.86 1.07-2.51-1.29-11.12-1.29-11.12s11.45 12.47 10.39 14.98zM130.59 149.12c-2.42 5.94-11.69 2-9.1-3.86 1.07-2.51 9.1-10.78 9.1-10.78s1.06 12.13 0 14.64z"
        className="st6"
      />
      <path
        d="M119.95 159.66c.28 5.23-.35 10.64-3.51 15.13-3.16 4.49-9.28 7.88-15.83 7.45-7.39-.49-13.35-5.58-16.33-11.06-2.25-4.14-3.31-8.62-4.41-12.99-1.62-6.47 3.74-2.16 8.65-.57 4.99 1.62 10.28 2.62 15.6 2.98 1.41.08 15.89.22 15.83-.94z"
        className="st7"
      />
      <path
        d="M80.91 116.01c.52 1.17 1.05 2.34 1.57 3.51M94.38 115.87c-.33 1.3-.65 2.59-.98 3.89M104.52 126.67l-2.79 2.1M116.5 132.25c1.24.79 2.14 2.1 2.44 3.53M129.26 128.89c-.23 1.33-.45 2.66-.68 3.98M141.5 139.43c-1.14.43-2.28.87-3.42 1.3"
        className="st5"
      />
      <path
        d="M126.87 120.23c12.61-8.89 21.26-4.22 25.92 3.63M96.96 99.2c-11.12-5-19.26.57-23.31 12.97"
        className="st7"
      />
    </g>
    <g id="blenderbody_2_">
      <g id="base_2_">
        <path
          d="M41.83 178.46c-.27 3.54-.54 7.02-.8 10.42 32.01 11.95 64.58 22.19 97.71 30.66 2.6.84 5.38-.59 6.22-3.19 6.27-5.26-73.26-24.89-103.13-37.89z"
          className="st8"
        />
        <path
          d="M151.51 195.96s-11.09 5.43-66.3-13.37c-20.31-6.09-33.54-11.94-42.45-16.63-.32 4.34-.65 8.65-.97 12.9 34.47 12.24 69.36 23.18 104.67 32.78 6.47 2.04 11.5-13.57 5.05-15.68z"
          className="st8"
        />
      </g>
      <g id="pitcher_2_">
        <path
          d="M224.71 56.47c-.4-.02-1.38-.08-2.78-.15-7.15 9.49-14.27 16.5-18.58 17.08-3.02.41-15.92-2.44-17.13-1.38-2.91 2.56-7.57 9.83-7.57 9.83 9.75-8.09 26.29 4.07 41.41-1.33 5.25-6.53 12.14-14.65 18.95-23.37-7.07-.32-13.2-.61-14.3-.68zM79.88 76.13c13.93 5.5 84 35.03 90.27 25.72.63-2.31-1.31-5.01-4.32-6.02-28.53-8.17-56.44-17.5-83.67-28.07-7.04-2.45-9.4 6.07-2.28 8.37z"
          className="st8"
        />
        <path
          d="M186.2 53.61c-.01-.32 0-.63-.01-.95-10.8-.55-27.2-1.29-29.07-1.41-2.55-.16-29.41-1.36-36.69-2.39-10.68-.55-26.7-1.53-40.2-2.44.53 7.89 1.18 15.18 1.93 21.33l83.3 29.47c11.96-13.66 22.71-27.74 32.09-42.3-6.38-.44-11.34-.91-11.35-1.31zM96.1 60.26c-.75-2.93-1.27-5.94-1.71-8.95M95.29 49.49l16.37 5.49M97.13 60.76l11.19 3.75"
          className="st8"
        />
      </g>
    </g>
    <g>
      <path
        fill="#ccc"
        stroke="#fff"
        strokeWidth="4.9999"
        d="M113.131927 236.566417l51.60472 3.990696-1.78872 23.1304-51.60472-3.990696z"
      />
      <path
        d="M92.82 262.08h86.55v15.17H92.82z"
        className="st10"
        transform="rotate(4.44 136.1334311 269.52917908)"
      />
      <path
        d="M70.37 279h129.38v8.03H70.37z"
        className="st10"
        transform="rotate(4.44 135.10643648 282.86875085)"
      />
    </g>
  </ScreenWrapper>
);

export default ScreenIcon;
